"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

var _util = require("../../util");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  to {\n    transform: rotate(1turn)\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var rotate = (0, _react.keyframes)(_templateObject());

var spinner = function spinner(theme) {
  return /*#__PURE__*/(0, _react.css)("position:relative;margin:0 auto;border-radius:50%;background:conic-gradient(#0000 10%, ", theme.color.info['300'], ");animation:", rotate, " 1s infinite linear;" + (process.env.NODE_ENV === "production" ? "" : ";label:spinner;"));
};

var small = function small(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";-webkit-mask:radial-gradient(\n    farthest-side,\n    #0000 calc(100% - ", (0, _util.rem)(3), "),\n    ", theme.color.info['300'], " 0\n  );mask:radial-gradient(\n    farthest-side,\n    #0000 calc(100% - ", (0, _util.rem)(3), "),\n    ", theme.color.info['300'], " 0\n  );" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var medium = function medium(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(48), ";height:", (0, _util.rem)(48), ";-webkit-mask:radial-gradient(\n    farthest-side,\n    #0000 calc(100% - ", (0, _util.rem)(4), "),\n    ", theme.color.info['300'], " 0\n  );mask:radial-gradient(\n    farthest-side,\n    #0000 calc(100% - ", (0, _util.rem)(4), "),\n    ", theme.color.info['300'], " 0\n  );" + (process.env.NODE_ENV === "production" ? "" : ";label:medium;"));
};

var large = function large(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(64), ";height:", (0, _util.rem)(64), ";-webkit-mask:radial-gradient(\n    farthest-side,\n    #0000 calc(100% - ", (0, _util.rem)(5), "),\n    ", theme.color.info['300'], " 0\n  );mask:radial-gradient(\n    farthest-side,\n    #0000 calc(100% - ", (0, _util.rem)(5), "),\n    ", theme.color.info['300'], " 0\n  );" + (process.env.NODE_ENV === "production" ? "" : ";label:large;"));
};

var styles = {
  spinner: spinner,
  small: small,
  medium: medium,
  large: large
};
exports.styles = styles;
//# sourceMappingURL=Spinner.styles.js.map